module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gc-Hc-Ib-Jb.f071224a.png";